import { createBrowserRouter } from "react-router";

export const RouterPrivate = createBrowserRouter([
	{
		path: "/invitation/:operationId?",
		lazy: () => import("../routes/invitation.$operationId/route"),
		HydrateFallback: () => null,
	},
	{
		path: "/prospect-invite/:token",
		lazy: () => import("../routes/prospect-invite.$token/route"),
		HydrateFallback: () => null,
	},
	{
		path: "/onboarding",
		lazy: () => import("../routes/onboarding/route"),
		HydrateFallback: () => null,
	},
	{
		path: "/",
		lazy: () => import("../routes/root"),
		HydrateFallback: () => null,
		children: [
			{
				index: true,
				lazy: () => import("../routes/_index"),
			},
			{
				lazy: () => import("../routes/app-layout"),
				children: [
					{
						lazy: () => import("../routes/app-admin"),
						children: [
							{
								path: "app-admin",
								lazy: () => import("../routes/app-admin._index/route"),
							},
							{
								path: "app-admin/orgs",
								lazy: () => import("../routes/app-admin.orgs._index/route"),
							},
							{
								path: "app-admin/orgs/:orgId",
								lazy: () => import("../routes/app-admin.orgs.$orgId/route"),
							},
							{
								path: "app-admin/users",
								lazy: () => import("../routes/app-admin.users._index/route"),
							},
							{
								path: "app-admin/coupons",
								lazy: () => import("../routes/app-admin.coupons._index/route"),
							},
							{
								path: "app-admin/plans",
								lazy: () => import("../routes/app-admin.plans._index/route"),
							},
							{
								path: "app-admin/plans/new",
								lazy: () => import("../routes/app-admin.plans.$planId/route"),
							},
							{
								path: "app-admin/plans/:planId",
								lazy: () => import("../routes/app-admin.plans.$planId/route"),
							},
							{
								path: "app-admin/apartment-sets",
								lazy: () =>
									import("../routes/app-admin.apartment-sets._index/route"),
							},
							{
								path: "app-admin/autodesk-exports",
								lazy: () =>
									import("../routes/app-admin.autodesk-exports._index/route"),
							},
						],
					},
					{
						path: "billing",
						lazy: () => import("../routes/billing._index/route"),
					},
					{
						path: "cookies",
						lazy: () => import("../routes/cookies._index/route"),
					},
					{
						path: "impressum",
						lazy: () => import("../routes/impressum._index/route"),
					},
					{
						lazy: () => import("../routes/org-settings"),
						children: [
							{
								path: "org/general",
								lazy: () => import("../routes/org.general._index/route"),
							},
							{
								path: "org/billing",
								lazy: () => import("../routes/org.billing._index/route"),
							},
							{
								path: "org/apartment-sets",
								lazy: () => import("../routes/org.apartment-sets._index/route"),
							},
							{
								path: "org/members",
								lazy: () => import("../routes/org.members._index/route"),
							},
						],
					},
					{
						path: "org/billing/order/:step",
						lazy: () => import("../routes/org.billing.order.$step/route"),
					},
					{
						path: "privacy",
						lazy: () => import("../routes/privacy._index/route"),
					},
					{
						path: "project",
						lazy: () => import("../routes/project._index/route"),
					},
					{
						path: "terms",
						lazy: () => import("../routes/terms._index/route"),
					},
				],
			},
			{
				path: "project/new",
				lazy: () => import("../routes/project.new/route"),
			},
			{
				path: "project/:projectId",
				lazy: () => import("../routes/project.$projectId/route"),
				children: [
					{
						path: "layout/:layoutId",
						lazy: () =>
							import("../routes/project.$projectId.layout.$layoutId/route"),
					},
					{
						path: "layout/:layoutId/json",
						lazy: () =>
							import(
								"../routes/project.$projectId.layout.$layoutId.json/route"
							),
					},
				],
			},
			{
				path: "*",
				lazy: () => import("../routes/$"),
			},
		],
	},
]);
